import { MutableRefObject } from 'react';

/**
 * Call in `useEffect` hooks. Make sure to return the result so that the
 * event listener is removed on unmount.
 */
export const onExteriorClick = (
    ref: MutableRefObject<HTMLDivElement | null>,
    callback: () => void) => {

    if (!document) {
        return;
    }

    const isOutsideRef = (target: EventTarget | null) => {
        return !(ref?.current as HTMLDivElement)?.contains(target as Node);
    };

    const onClick = (e: MouseEvent) => {
        if (isOutsideRef(e.target)) {
            callback();
        }
    };

    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
};